<template>
  <div>
    <v-dialog scrollable max-width="500" v-model="model" persistent>
      <v-card v-if="loading">
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <div v-else>
        <material-card
          :title="$t('components.employers.employer_details.view_balance_statement')"
          :color="$vuetify.theme.themes.light.primary"
          icon="contact_page"
        >
          <v-card-text>
            <v-form v-model="valid">
            <trans-select2
              v-model="selected"
              propertyName="period"
              :items="billingPeriods"
              :label="
                $t('components.invoices.new_invoice_dialog.billing_period')
              "
              itemValue="Id"
              field="FullName"
              :rules="[$rules.required]"
              class="required"
            ></trans-select2>
          </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" @click="getStatements" :disabled="!valid">
              {{ $t("components.employers.balance_statements.get_statements") }}
            </v-btn>
            <v-btn text @click="$emit('close')">
              {{ $t("globals.cancel") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </div>
    </v-dialog>
    <preview-report-dialog :html="report" :model="showReport" @close="showReport=false;$emit('close')"/>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import moment from "moment";
import TransSelect2 from "@/components/TransSelect2";
import PreviewReportDialog from "./PreviewReportDialog.vue";

export default {
  props: ["model", "employerIdentityId"],
  components: { ErrorHandler, TransSelect2, PreviewReportDialog },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["settings"]),
  },
  data() {
    return {
      loading: false,
      error: null,
      billingPeriods: [],
      now: null,
      selected: {},
      report: null,
      showReport: false,
      valid: false
    };
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.loadData();
        }
      },
    },
  },

  methods: {
    ...mapActions("plansMembers", [
      "getCompletedBillingPeriods",
      "getEmployerStatements",
    ]),

    async loadData() {
      try {
        this.loading = true;
        this.report = null;
        this.showReport = false;
        this.selected = {};
        var m = moment(); // get "now" as a moment
        this.now = m.format(); // the ISO format is the default so no parameters are needed
        this.billingPeriods = (
          await this.getCompletedBillingPeriods({
            planIdentityId: this.selectedPlan.Id,
            now: this.now,
          })
        ).data.value;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },

    async getStatements() {
      try {
        this.loading = true;
        this.report = (
          await this.getEmployerStatements({
            planIdentityId: this.selectedPlan.Id,
            employerIdentityId: this.employerIdentityId,
            payload: {
              Date: this.now,
              BillingTermIds: [this.selected.period.Id],
            },
          })
        ).data;
        this.showReport = true;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
